import { useEffect, useState } from "react";
import { Container, Button as Buttons } from "react-bootstrap";
import CardItem from "../CardItem";
// import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../Config";
import { Spin } from "antd";

const Mutton = () => {
  const [products, setProducts] = useState<any[]>([]);

  const getAllProduct = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/product?category=mutton&page=${1}&limit=${6}&isDeleted=false`
      );
      if(response.data.products){
        setProducts(response.data.products);
      }
      else {
        setProducts([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const navigate = useNavigate();
  const handleNavMutton = () => {
    navigate("/mutton");
  };

  useEffect(() => {
    getAllProduct();
  }, []);

  return (
    <>
      <section className="py-4">
        <Container>
          {/* <h2 className="title2 py-3 text-center">
            Buy <span>Mutton</span> Meat Online
          </h2> */}
          <div className="row">
            {/* <div className="col-lg-3 sm-chickenbanner">
              <div style={{ height: "100%" }}>
                <img
                  className="img-fluid mutton-poster"
                  src="/assets/goatposter.webp"
                  loading="lazy"
                  alt="img"
                />
              </div>
            </div> */}
            <div className="">
              <div>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h2 className="fw-bold">Buy Mutton meat Online</h2>
                  <Buttons variant="light" className="fw-bold" onClick={()=>navigate("/mutton")}>
                    See More →
                  </Buttons>
                </div>
                <div className="row">
                  {products.length ? (
                    products.map((product) => (
                      <div className="col-6 col-lg-3 col-md-4" key={product._id}>
                        <CardItem  product={product} />
                      </div>
                    ))
                  ) : (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "70vh" }}
                    >
                      <Spin size="large" className="custom-spin" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="text-center pb-3 pt-4">
            <Button
              variant="contained"
              className="see-btn"
              onClick={handleNavMutton}
            >
              See More
            </Button>
          </div> */}
        </Container>
      </section>
    </>
  );
};

export default Mutton;
